import styled from "styled-components";

export const Title = styled.div`
    font-size: clamp(1rem, 3vw, 1.8rem);
    padding: 20px 0;
    font-weight: bold;
    line-height: 1.2;   
`;
export const HighlightedTitle = styled.div`
    font-size: clamp(1rem, 3vw, 1.8rem);
    padding: 20px 0;
    font-weight: bold;
    color: #2bb2d0;
`;
export const Text = styled.div`
    font-size: clamp(0.9rem, 2.2vw, 1.1rem);
    white-space: pre-line;
    padding-bottom: 20px;
`;

export const HighlightedText = styled.span`
    font-size: clamp(0.9rem, 2.2vw, 1.1rem);
    white-space: pre-line;
    color: #2bb2d0;
    font-weight: bold;
`;

export const Section = styled.div`
    font-family: 'Gotham Rounded SSm A', 'Gotham Rounded SSm B', sans-serif;
    color: #1E3C91;
    padding-bottom: 20px;
`;

export const List = styled.ul`
    font-size: 1.1rem;
    padding: 0 0 20px 0;
`;

export const ListItem = styled.li`
    display: flex;
    align-items: flex-start;
    padding-bottom: 10px;
`;

export const ListItemText = styled.div`
  white-space: pre-line;
`;

export const BulletStyle = styled.span`
    margin-top: 2px;
    padding-right: 10px;
`;

export const Button = styled.a<{ bg?: string }>`
    position: relative;
    border-radius: 50px;
    margin-top: 20px;
    padding: 15px 90px;
    color: white;
    font-size: 1rem;
    text-decoration: none;
    text-align: center;
    font-family: 'Gotham Rounded SSm A', 'Gotham Rounded SSm B', sans-serif;
    background: ${({ bg }) => bg || 'linear-gradient(90deg, #F9AF06 10%, #EF0787 85%)'};
    transition: all 0.2s ease;
    
    &:hover {
        color: white;
        left: 4px;
        top: 4px;
        cursor: pointer;
    }
`;

export const Banner = styled.div.attrs({
    className: "container-fluid",
})`
    font-family: 'Gotham Rounded SSm A', 'Gotham Rounded SSm B', sans-serif;
    background: linear-gradient(to right, #F9AF06 20%, #EF0787 70%);
    color: white;
`;

export const BannerTitle = styled.div`
    font-family: 'Gotham Rounded SSm A', 'Gotham Rounded SSm B', sans-serif;
    text-align: start;
    font-size: clamp(0.9rem, 3.6vw, 3.25rem);;
    white-space: pre;
    line-height: 1.2;
    padding-left: 15%;
    
    @media (max-width: 992px) {
        padding-left: 5%;
    }
    
    @media (max-width: 480px) {
        padding-left: 10%;
    }
`;

export const BannerButton = styled.a`
    position: relative;
    border-radius: 50px;
    margin-top: 1rem;
    padding: 20px 80px;
    color: white;
    font-size: 1rem;
    text-decoration: none;
    text-align: center;
    font-family: 'Gotham Rounded SSm A', 'Gotham Rounded SSm B', sans-serif;
    background-color: #38327a;
    transition: all 0.2s ease;
    width: fit-content;
    white-space: nowrap;
    margin-left: 15%;
    
    &:hover {
        color: white;
        left: 4px;
        top: 4px;
        cursor: pointer;
    }

    @media (max-width: 992px) {
        padding: 0.6rem 1.5rem;
        margin-left: 5%;
        font-size: 0.9rem;
    }
    @media (max-width: 480px) {
        padding: 0.5rem 1rem;
        font-size: 0.85rem;
        margin-left: 0;
    }
`;

export const Circle = styled.div`
    position: absolute;
    left: 100%;
    top: 32%;
    transform: translate(-50%, -50%);
    width: 9.5vw;
    height: 9.5vw;
    max-width: 150px;
    max-height: 150px;
    background-color: #334895;
    border-radius: 50%;
    z-index: 1;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    white-space: pre;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    font-size: clamp(0.4rem, 2vw, 1.4rem);
    font-weight: bold;
    line-height: 1.5;
`